import { render, staticRenderFns } from "./PreventivoOnDemand.vue?vue&type=template&id=61a3918e&scoped=true"
import script from "./PreventivoOnDemand.vue?vue&type=script&lang=js"
export * from "./PreventivoOnDemand.vue?vue&type=script&lang=js"
import style0 from "./PreventivoOnDemand.vue?vue&type=style&index=0&id=61a3918e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a3918e",
  null
  
)

export default component.exports